import {Modal} from "@tag/tag-components-react-v4";
import AppGroupService from "../../APP/services/AppGroupService";

function APPOctoSyncAllModal(props: { visible: boolean, handleClose: Function, setAlert: Function, setLoading: Function }) {

    const renderModalContent = () => {
        let modalContent;

        modalContent = (
            <div>
                <p>
                    Please note, <strong>Syncing All</strong> on one environment which sits under one corporate site e.g. Production,
                    will remove all <strong>Octopus Tenants</strong> that come from other environments which use the same octopus instance,
                    and have their own CorpSite e.g. AcrStaging.
                </p>
                <p>
                    Until we find a solution around this, you should do a sync all on the largest set (production) then
                    sync each individual app group on the smaller set (AcrStaging) when you need to 'sync all' to make sure no tenants are lost.
                </p>
            </div>
        )
        
        return modalContent;
    }
    
    const handleOctopusSyncAll = () => {
        props.setLoading(true);
        AppGroupService.octopusSyncForAll()
            .then(() => {
                props.setLoading(false);
                props.setAlert({type: 'success', message: 'All environments synced without issue'});
                props.handleClose();
            })
            .catch((response) => {
                props.setLoading(false);
                props.setAlert({type: 'error', message: 'There was an issue with the sync, please investigate'});
                props.handleClose();
            })
    }

    let content;
    content = <>
        <Modal
            visible={props.visible}
            accent='teal'
            heading={'Are you sure you want to sync all App Groups?'}
            onCancelButtonClick={() => {
                props.handleClose();
            }}
            onPrimaryButtonClick={() => handleOctopusSyncAll()}
            onClose={() => props.handleClose()}
        >
            <div>
                {renderModalContent()}
            </div>
        </Modal>
    </>

    return (
        <>
            {content}
        </>
    )

}

export default APPOctoSyncAllModal;